import JSBI from 'jsbi';

import { ApiLevelTwoOrderBookRow } from '#/api/types';
import { formatNumber } from '#/lib/display/formatting';
import { decimalToPip, pipToDecimal } from '#/lib/numbers';

export interface LevelTwoOrderBookRow {
  price: string;
  priceFormatted: string;
  pricePip: JSBI;
  quantity: string;
  quantityPip: JSBI;
  total: number;
}

// type RowsType = OrderedMap<LevelTwoOrderBookRow['price'], LevelTwoOrderBookRow>;
export type RowsType = LevelTwoOrderBookRow[];

export const prepareTransformApiOrderBookRow =
  (tickSizeVisibleDecimals: number, stepSizeVisibleDecimals: number) =>
  (row: ApiLevelTwoOrderBookRow): LevelTwoOrderBookRow => {
    const [price, quantity, _ordersCount] = row;
    const priceNumber = Number(price);
    return {
      price: priceNumber.toFixed(tickSizeVisibleDecimals),
      priceFormatted: formatNumber(priceNumber, {
        fixedDecimals: tickSizeVisibleDecimals,
      }),
      pricePip: decimalToPip(price),
      quantity: Number(quantity).toFixed(stepSizeVisibleDecimals),
      quantityPip: decimalToPip(quantity),
      total: Number(price) * Number(quantity),
    };
  };

/**
 * Note: this have to be calculated from ORIGINAL orderbook - not grouped one
 * (original tick size only)
 */
export const calculateSpread = (
  asks: LevelTwoOrderBookRow[],
  bids: LevelTwoOrderBookRow[]
) => {
  const bottomAsk = asks[asks.length - 1];
  const topBid = bids[0];
  const spreadPip =
    asks.length && bids.length
      ? JSBI.subtract(bottomAsk.pricePip, topBid.pricePip)
      : undefined;

  const spreadPercentage = spreadPip
    ? 100 * (Number(pipToDecimal(spreadPip)) / Number(bottomAsk.price))
    : 0;
  return {
    bottomAsk,
    topBid,
    spreadPercentage,
    spreadPip,
  };
};
